import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';
import { setRouter } from '@/app/routes/navigation-state';

/**
 * RouterBridge — mounts inside the TanStack Router tree and wires the
 * router instance into navigationState.ts so non-React consumers
 * (e.g. useChatStore) can read active IDs via getActiveDocumentId().
 *
 * Must be rendered as a child of <RouterProvider>.
 */
export function RouterBridge() {
  const router = useRouter();

  useEffect(() => {
    setRouter(router);
  }, [router]);

  return null;
}
